module.exports = __webpack_public_path__ + "static/media/menu_pagamentos.1928f0d2.png";